import {Col, Row, Button, Form} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import AddressForm from "../form/addressForm";
import ApiService from "../../services/ApiService";
import {useLocation, useNavigate} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";
import GenericErrorModal from "../modal/genericErrorModal";

const Address = () => {

    const [nome, setName] = useState("")
    const [citta, setCitta] = useState("")
    const [nazione, setNazione] = useState("")
    const [cognome, setCognome] = useState("")
    const [recapito, setRecapito] = useState("")
    const [indirizzo, setIndirizzo] = useState("")
    const [codicePostale, setCodicePostale] = useState("")
    const [userData, setUserData] = useState();
    const [doneUpdate, setDoneUpdate] = useState(0);
    const [accettoCondizioni, setAccettoCondizioni] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    useEffect(() => {
        ApiService.getUserDataFromId().then(result => {

            let userDataByAddressType = result.userDataDtoList[0];
            if (userDataByAddressType != null) {
                setCurrentUser(userDataByAddressType)
            }

            setUserData(result.userDataDtoList)
        })
            .catch(responseError => setErrorModal({
                state: true,
                title: "Errore generico",
                body: "Ok"
            }))

    }, [doneUpdate])

    function setCurrentUser(currentUserData) {
        setName(currentUserData.firstName)
        setCognome(currentUserData.lastName)
        setNazione(currentUserData.country)
        setIndirizzo(currentUserData.address)
        setCodicePostale(currentUserData.zip)
        setRecapito(currentUserData.phone)
        setCitta(currentUserData.city)
    }

    const handleRegistraIndirizzo = async (e) => {
        e.preventDefault();

        let userDataPrimary = {
            firstName: nome,
            lastName: cognome,
            organization: null,
            address: indirizzo,
            address2: null,
            zip: codicePostale,
            city: citta,
            country: nazione,
            phone: recapito,
        }

        await createOrUpdateUserData(userDataPrimary)
    }

    const createOrUpdateUserData = async (userDataParams) => {

        let userDataByType = userData[0];
        if (location.state?.editMode || userDataByType != null) {
            ApiService.editUserData(userDataParams, userDataByType.id).then(response => {
                if(location.state?.checkout){
                    procediAlPagamento()
                } else {
                    navigate(AppRoute.ACCOUNT)
                }
            })
        } else {
            ApiService.createUserData(userDataParams).then(response => {
                if(location.state?.checkout){
                    procediAlPagamento()
                }
            })
        }

        setDoneUpdate(Date.now())
    }

    const procediAlPagamento = () =>{
        ApiService.getBasketData().then(activeBasket => {

            let basketToPay ={
                status: "Created",
                basketId: activeBasket.id
            }

            setTimeout(() => {
                ApiService.payCartAndPlaceOrder(basketToPay).then(response => {
                    window.location.href = response;
                })
            }, 500);

        })
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Indirizzo principale</h2>
                        </Col>
                    </Row>

                    <Row className={'my-4'}>
                        <Col xs={12}>
                            <AddressForm nome={nome} setNome={setName} cognome={cognome} setCognome={setCognome} citta={citta} setCitta={setCitta} indirizzo={indirizzo} setIndirizzo={setIndirizzo}
                                         nazione={nazione} setNazione={setNazione} recapito={recapito} setRecapito={setRecapito}
                                         codicePostale={codicePostale} setCoicePostale={setCodicePostale} editMode={location.state?.editMode}/>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row>
                <Col lg={6}>
                    <Row className={'mb-3'}>
                        <Col xs={12}>
                            <Form.Check
                                type="checkbox"
                                id="accetto-condizioni"
                                checked={accettoCondizioni}
                                onChange={(e) => setAccettoCondizioni(e.target.checked)}
                                label={
                                    <span>
                                        Accetto le <a href="https://www.nuotosportlocarno.ch/nsl/corsi/condizioni-generali.html" target="_blank" rel="noopener noreferrer">Condizioni Generali</a>
                                    </span>
                                }
                            />
                        </Col>
                    </Row>
                    <Row className={'my-4'}>
                        <Col xs={12}>
                            <div className={'d-flex justify-content-end'}>
                                <Button variant={'primary'} disabled={(nome === "" || cognome === "" ||indirizzo === ""
                                    || nazione === "" || recapito === "" || codicePostale === ""
                                    || citta === "" || !accettoCondizioni)} className={'px-4 fw-bold'}
                                        onClick={(e) => handleRegistraIndirizzo(e)}
                                >{location.state?.checkout? "Procedi al pagamento" : "Procedi"}</Button>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

        </>

    );
}

export default Address;
